import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import api from '../../../api/api';
import { handleRequestHelper } from '../../../utils/helpers';

export const useEditRecommendationListPage = () => {
  const { listId } = useParams();
  const [list, setList] = useState(null);

  const getList = async () => {
    await handleRequestHelper({
      endpoint: () => api.getRecommendationList(listId),
      onSuccess: ({ curatedEventList }) => {
        curatedEventList.events = curatedEventList.events.map((event) => ({
          ...event,
          image: event.listImage ?? undefined,
        }));
        setList(curatedEventList);
      },
    });
  };

  useEffect(() => {
    getList(listId);
  }, [listId]);

  return { list };
};
